module.exports = __webpack_public_path__ + "img/Zasialnie główne osiedla.5af0d17c.jpg";